import { DateHelper } from "../../helpers/DateHelper";

export class Client{
    id: number;
    name: string;
    company: string;
    dateAccredited: string = DateHelper.getDateNowString(); //date string
    createdBy: number;
    createdDate: string;
    updatedBy: number;
    updatedDate: string;
}



// WEBPACK FOOTER //
// ./src/app/models/clients/client.ts